var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Component, Input, Output, EventEmitter, ViewChild } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { UsuarioService } from '../../services/usuario.service';
import { CommonService } from '../../services/common.service';
import { ExpedienteService } from '../../services/expediente.service';
import { ServiceException } from '../../model/exception';
import { Message } from '../../common/dialog/mensaje.component';
import { MensajeConfig } from '../../common/dialog/mensaje.config';
var RepreCausaPopupComponent = (function () {
    function RepreCausaPopupComponent(_usrService, builder, _expService, _comService) {
        this._usrService = _usrService;
        this.builder = builder;
        this._expService = _expService;
        this._comService = _comService;
        this.onClose = new EventEmitter(false);
        this.onComplete = new EventEmitter();
        this.tipoVinculo = { cod: "", descr: "", id: 0, tipo: 0, excluirForcar: false };
        this.repre = { codigo: "", nombreApellido: "", mail: "", tipoVin: this.tipoVinculo, apellido: "", nombre: "", numero: "", tdo_cod: "", pro_id: 0 };
        this.visible = false;
        this.esModoAlta = true;
        this.instanceId = Math.floor(Math.random() * 1000000);
    }
    RepreCausaPopupComponent.prototype.ngOnInit = function () {
        this.hideErrorMsg();
    };
    RepreCausaPopupComponent.prototype.newRepre = function () {
        this.hideErrorMsg();
        this.visible = true;
        this.repre = { codigo: "", nombreApellido: "", mail: "", tipoVin: this.tipoVinculo, apellido: "", nombre: "", numero: "", tdo_cod: "", pro_id: 0 };
        this._comService.emitBlocking(false);
    };
    RepreCausaPopupComponent.prototype.finalize = function () {
        this.visible = false;
        //this.repre = {tvi_id:0,tvi_descr:"",apellido:"",nombre:"",numero:"",tdo_cod:""};
        this.hideErrorMsg();
    };
    RepreCausaPopupComponent.prototype.onClickSave = function () {
        if (this.SuccessMessageIsVisible) {
            return;
        }
        this.hideErrorMsg();
        if (this.validate()) {
            this.onComplete.emit(this.repre);
            this.onClose.emit(1);
            document.getElementById('_cancelButton').click();
        }
        else {
            this.showErrorMessage("Debe ingresar los datos del Representante");
        }
    };
    RepreCausaPopupComponent.prototype.onClickBuscarPro = function () {
        var _this = this;
        if (this.repre.tdo_cod !== "" && this.repre.numero !== "") {
            //console.log("repre " + JSON.stringify(this.repre));
            //console.log("repre " + btoa(JSON.stringify(this.repre)));
            this._expService.findProfesional(JSON.stringify(this.repre)).subscribe(function (response) {
                _this.repre.nombre = response.nombre;
                _this.repre.apellido = response.apellido;
                _this.repre.pro_id = response.pro_id;
            }, function (error) {
                var exc = ServiceException.parse(error.json());
                _this.repre.nombre = "";
                _this.repre.apellido = "";
                _this.repre.pro_id = 0;
                //console.log(exc.toString());
                //alert(exc.description);
                _this.mensajeConfigSource = new MensajeConfig("Busqueda de Representante", false, "", true, "Aceptar");
                _this.msgPopup.showMessage(exc.getDescripcion());
                //that.modalEscritoEvent(SIGNER_STATUS.CLOSED.code);
                // that._comService.emitBlocking(false);
            });
        }
    };
    RepreCausaPopupComponent.prototype.onClickCancelar = function () {
        this.onClose.emit(1);
    };
    RepreCausaPopupComponent.prototype.onChangeSelectTvi = function (selected) {
        var vinculo;
        vinculo = this.tviListRepre.find(function (item) { return item.id == selected; });
        this.repre.tipoVin = vinculo;
    };
    RepreCausaPopupComponent.prototype.validate = function () {
        if (this.repre.tipoVin.id == 0) {
            return false;
        }
        if (this.repre.apellido == "") {
            return false;
        }
        if (this.repre.nombre == "") {
            return false;
        }
        if (this.repre.numero == "") {
            return false;
        }
        if (this.repre.tdo_cod == "") {
            return false;
        }
        return true;
    };
    RepreCausaPopupComponent.prototype.showErrorMessage = function (msg) {
        this.ErrorMsg = msg;
        this.ErrorMessageIsVisible = true;
    };
    RepreCausaPopupComponent.prototype.showSuccessMessage = function (msg) {
        this.SuccessMsg = msg;
        this.SuccessMessageIsVisible = true;
    };
    RepreCausaPopupComponent.prototype.hideErrorMsg = function () {
        this.ErrorMsg = "";
        this.ErrorMessageIsVisible = false;
        this.hideSuccessMsg();
    };
    RepreCausaPopupComponent.prototype.hideSuccessMsg = function () {
        this.SuccessMsg = "";
        this.SuccessMessageIsVisible = false;
    };
    RepreCausaPopupComponent.prototype._keyPress = function (event) {
        var pattern = /[.,\-+]/;
        var inputChar = String.fromCharCode(event.charCode);
        if ((event.charCode != 0 && pattern.test(inputChar)) || event.charCode == 101) {
            event.preventDefault();
        }
    };
    return RepreCausaPopupComponent;
}());
__decorate([
    Output(),
    __metadata("design:type", EventEmitter)
], RepreCausaPopupComponent.prototype, "onClose", void 0);
__decorate([
    Output(),
    __metadata("design:type", EventEmitter)
], RepreCausaPopupComponent.prototype, "onComplete", void 0);
__decorate([
    Input(),
    __metadata("design:type", Array)
], RepreCausaPopupComponent.prototype, "tviListRepre", void 0);
__decorate([
    Input(),
    __metadata("design:type", Array)
], RepreCausaPopupComponent.prototype, "tdocList", void 0);
__decorate([
    ViewChild(Message),
    __metadata("design:type", Message)
], RepreCausaPopupComponent.prototype, "msgPopup", void 0);
RepreCausaPopupComponent = __decorate([
    Component({
        moduleId: module.id,
        selector: 'repre-causa-popup',
        templateUrl: 'repre-causa-popup.component.html'
    }),
    __metadata("design:paramtypes", [UsuarioService,
        FormBuilder, ExpedienteService,
        CommonService])
], RepreCausaPopupComponent);
export { RepreCausaPopupComponent };
//# sourceMappingURL=repre-causa-popup.component.js.map